import axiosInstanceV2 from "../config/axios-v2-config";
const BASE_PRESCRIPTION_APPOINTMENT_URL = "/v2/prescription-appointment";

export const addNewPrescriptionAppointment = async ({
  appointmentId,
  drugNameId,
  frequencyId,
  lengthId,
  notes,
}: {
  appointmentId: string;
  drugNameId: string;
  frequencyId: string;
  lengthId: string;
  notes: string | undefined;
}) => {
  try {
    let requestBody: {
      appointmentId: string;
      drugNameId: string;
      frequencyId: string;
      lengthId: string;
      notes?: string;
    } = {
      appointmentId: appointmentId,
      drugNameId: drugNameId,
      frequencyId: frequencyId,
      lengthId: lengthId,
    };
    if (notes !== undefined && notes !== "") {
      requestBody.notes = notes;
    }
    const response = await axiosInstanceV2.post(
      BASE_PRESCRIPTION_APPOINTMENT_URL,
      requestBody
    );
    if (response.status !== 201) {
      throw Error("Unable save prescription appointment data");
    } else {
      return response.data;
    }
  } catch (error) {
    console.log(error);
    throw Error("Unable save prescription appointment data");
  }
};

export const getPrescriptionAppointmentByAppointmentId = async (
  appointmentId: String
) => {
  try {
    const response = await axiosInstanceV2.get(
      BASE_PRESCRIPTION_APPOINTMENT_URL,
      {
        params: { appointmentId: appointmentId },
      }
    );
    if (response.status !== 200) {
      throw Error("Unable retrieve prescription appointment data");
    } else {
      return response.data;
    }
  } catch (error) {
    console.log(error);
    throw Error("Unable retrieve prescription appointment data");
  }
};

export const deletePrescriptionAppointment = async (prescriptionId: string) => {
  try {
    const response = await axiosInstanceV2.delete(
      BASE_PRESCRIPTION_APPOINTMENT_URL,
      {
        params: {
          prescriptionId: prescriptionId,
        },
      }
    );
    if (response.status !== 204) {
      throw Error("Unable delete prescription appointment data");
    } else {
      return response.data;
    }
  } catch (error) {
    console.log(error);
    throw Error("Unable delete prescription appointment data");
  }
};
